var chunkMapping = {
	"483": [
		41483
	]
};
var idToExternalAndNameMapping = {
	"41483": [
		"default",
		"./GlobalSearch",
		32587
	]
};
var idToRemoteMap = {
	"41483": [
		{
			"externalType": "script",
			"name": "scope_sravni__mf_search",
			"externalModuleId": 32587
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}